import React from 'react';
import { Image, Group, Rect } from 'react-konva';
import useImage from 'use-image';
import { usePrevious } from 'hooks';
import { color } from 'styles/settings';
import { SurfaceNodeUnion } from 'graphql/types';

// This is necessary to prevent the image from overflowing its container
// and causing issues with the parent's borders
const IMAGE_SIZE_TWEAK = 4;

export interface NodeSnapshotProps {
  width: number;
  height: number;
  node: SurfaceNodeUnion;
  isSelected?: boolean;
  scale: number;
}

const defaultProps = {
  scale: 1
};

function NodeSnapshot(props: NodeSnapshotProps) {
  const { node , scale } = props;

  //@ts-ignore
  const url = node?.url;

  const previousUpdatedAt = usePrevious(node.updatedAt);

  const imageUrl = React.useMemo(
    () =>
      resizedImage(
        url,
        props.width - IMAGE_SIZE_TWEAK,
        props.height - IMAGE_SIZE_TWEAK,
      ),
    [node.updatedAt],
  );

  const [image] = useImage(imageUrl);

  const [imageElement, setImageElement] = React.useState<
    HTMLImageElement | undefined
  >(undefined);

  React.useEffect(() => {
    if (image) {
      setImageElement(image);
    }
  }, [image]);

  React.useEffect(() => {
    return () => {
      if (url?.includes('blob:') && url?.includes(window.location.host)) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);

  function resizedImage(url, width, height): string {
    if (url.includes('blob:') && url.includes(window.location.host)) {
      return url;
    }
    const w = Math.max(width/scale,400 )
    const h = Math.max(height/scale,400 )
    const fullUrlX = `https://images.weserv.nl/?url=${encodeURIComponent(
     // "https://media.istockphoto.com/photos/historic-city-of-graz-with-main-square-styria-austria-picture-id1018156144",
     url
    )}&w=${w}&h=${h}&fit=contain&cbg=transparent`;
    const fullUrl = node.type == "BACKGROUND" ?url : fullUrlX


    console.log( "SCALE ", width , scale  , h , node.type)

    if (node.type != "BACKGROUND" && node.updatedAt && node.updatedAt !== previousUpdatedAt) {
      return fullUrl.concat('&updatedAt=' + node.updatedAt);
    }

    return fullUrl;
  }

  const imageProps = {
    x: IMAGE_SIZE_TWEAK / 2,
    y: IMAGE_SIZE_TWEAK / 2,
    width: props.width - IMAGE_SIZE_TWEAK ,
    height: props.height - IMAGE_SIZE_TWEAK ,
  };

  const empty = node.type == "BACKGROUND" ? {stroke: color.brand.blueLight, 'stroke-width': '1px'} : {}

  return React.useMemo(
    () => (
      <Group>
        <Rect
          width={props.width}
          height={props.height}
          {...(props.isSelected
            ? { stroke: color.brand.greenDark, 'stroke-width': '2px' }
            : empty)}
            
        />
        <Image image={imageElement} {...imageProps} />
      </Group>
    ),
    [Boolean(imageElement), props.height, props.width],
  );
}

NodeSnapshot.defaultProps = defaultProps;

export default NodeSnapshot;
